export const AFILIADO_AGREGADO = "El afiliado ha sido ingresado al padron, es necesaria la autorización del operador para resolver la solicitud";
export const AFILIADO_AGREGADO_ACTIVO = "El afiliado ha sido ingresado al padron y su solicitud resuelta en estado Activo";
export const AFILIADO_ACTUALIZADO = "Se han modificado los datos del Afiliado!";
export const AFILIADO_BAJA = "El afiliado ha sido dado de baja";
export const AFILIADO_REACTIVADO = "El afiliado ha sido reactivado";
export const AFILIADO_SOLICITUDRESUELTA = "Solicitud resuelta en estado";
export const AFILIADO_DATOSAFIPACTUALIZADO = "Se han actualizado los Datos ARCA";
